import { FC } from "react"
import { Safety } from "../../../module/safeties/containers/safety"

export const SafetyPage: FC = () => <Safety />
